import { useContext, useEffect, useState } from 'react';
import { IGame } from '../../../../../../store/player/games/store';
import { IEventItem } from '../../../../../../store/player/events/store';
import { GlobalContext } from '../../../../../../store';

export const useShotgunGameMetadata = (currentGame?: IGame) => {
  const { events } = useContext(GlobalContext);

  const [eventId, setEventId] = useState<number>();
  const [event, setEvent] = useState<IEventItem>();
  const [isShotgun, setIsShotgun] = useState(false);
  const [holeAssignment, setHoleAssignment] = useState('');
  const [startingHole, setStartingHole] = useState(0);
  const [startingPosition, setStartingPosition] = useState('a');

  useEffect(() => {
    if (currentGame) {
      const {
        startingHole: newStartingHole,
        startingPosition: newStartingPosition
      } = currentGame.group;

      if (newStartingHole) {
        setStartingHole(newStartingHole);
      }

      if (newStartingPosition) {
        setStartingPosition(newStartingPosition);
      }

      const newEventId = currentGame.round.event;

      setEventId(newEventId);
    }
  }, [currentGame]);

  useEffect(() => {
    if (eventId) {
      if (events.all[Number(eventId)]) {
        setEvent(events.all[Number(eventId)]);
      }
      if (events[Number(eventId)]) {
        setEvent(events[Number(eventId)]);
      }
    }
  }, [events, eventId]);

  useEffect(() => {
    if (event && event.rounds.length > 0) {
      setIsShotgun(event.rounds[0].shotgunStart);
    }
  }, [event]);

  useEffect(() => {
    if (isShotgun) {
      setHoleAssignment(`${Number(startingHole) + 1}${(startingPosition || '').toUpperCase()}`);
    }
  }, [isShotgun]);

  return { holeAssignment, isShotgun, eventId, startingHole };
};
